// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7d6ca0a9","453":"6e00081d"}[chunkId] + ".chunk.js";
};